/* eslint-disable no-undef */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  StyleSheet,
  Text,
  View,
  ViewPropTypes as RNViewPropTypes,
  ScrollView,
} from 'react-native';
import { getMeasure, getResponsiveStyle, getWidth, widthInPercentage } from '../utils/appUtils';
import TextInput from './customTextInput';

// Keep this line for downwards compatibility with RN.
// eslint-disable-next-line react/forbid-foreign-prop-types
const ViewPropTypes = RNViewPropTypes || View.propTypes;

class Autocomplete extends Component {
  static propTypes = {
    ...TextInput.propTypes,
    /**
     * These styles will be applied to the container which
     * surrounds the autocomplete component.
     */
    containerStyle: ViewPropTypes.style,
    /**
     * Assign an array of data objects which should be
     * rendered in respect to the entered text.
     */
    data: PropTypes.array,
    /**
     * Set to `true` to hide the suggestion list.
     */
    hideResults: PropTypes.bool,
    /*
     * These styles will be applied to the container which surrounds
     * the textInput component.
     */
    inputContainerStyle: ViewPropTypes.style,
    /*
     * Set `keyboardShouldPersistTaps` to true if RN version is <= 0.39.
     */
    keyboardShouldPersistTaps: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]),
    /*
     * These styles will be applied to the container which surrounds
     * the result list.
     */
    listContainerStyle: ViewPropTypes.style,
    /**
     * These style will be applied to the result list.
     */
    listStyle: ViewPropTypes.style,
    /**
     * `onShowResults` will be called when list is going to
     * show/hide results.
     */
    onShowResults: PropTypes.func,
    /**
     * method for intercepting swipe on ListView. Used for ScrollView support on Android
     */
    onStartShouldSetResponderCapture: PropTypes.func,
    /**
     * `renderItem` will be called to render the data objects
     * which will be displayed in the result view below the
     * text input.
     */
    renderItem: PropTypes.func,
    keyExtractor: PropTypes.func,
    /**
     * `renderSeparator` will be called to render the list separators
     * which will be displayed between the list elements in the result view
     * below the text input.
     */
    renderSeparator: PropTypes.func,
    /**
     * renders custom TextInput. All props passed to this function.
     */
    renderTextInput: PropTypes.func,
    flatListProps: PropTypes.object
  };

  static defaultProps = {
    data: [],
    keyboardShouldPersistTaps: 'always',
    onStartShouldSetResponderCapture: () => false,
    renderItem: ({ item }) => <Text>{item}</Text>,
    renderSeparator: null,
    renderTextInput: props => (
      <TextInput {...props} style={props.inputStyle} autoFocus={false} />
    ),
    flatListProps: {}
  };

  constructor(props) {
    super(props);
    this.resultList = null;
    this.textInput = null;
    this.inputHeight = 0;

    this.onRefListView = this.onRefListView.bind(this);
    this.onRefTextInput = this.onRefTextInput.bind(this);
    this.onEndEditing = this.onEndEditing.bind(this);
  }

  onEndEditing(e) {
    this.props.onEndEditing && this.props.onEndEditing(e);
  }

  onRefListView(resultList) {
    this.resultList = resultList;
  }

  onRefTextInput(textInput) {
    this.textInput = textInput;
  }

  /**
   * Proxy `blur()` to autocomplete's text input.
   */
  blur() {
    const { textInput } = this;
    textInput && textInput.blur();
  }

  /**
   * Proxy `focus()` to autocomplete's text input.
   */
  focus() {
    const { textInput } = this;
    textInput && textInput.focus();
  }

  /**
   * Proxy `isFocused()` to autocomplete's text input.
   */
  isFocused() {
    const { textInput } = this;
    return textInput && textInput.isFocused();
  }

  renderResultList(newHomescreen) {
    const {
      data,
      listStyle,
      renderItem,
      keyExtractor,
      renderSeparator,
      keyboardShouldPersistTaps,
      flatListProps,
      onEndReached,
      onEndReachedThreshold,
      listContainerStyle,
      nestedScrollEnabled,
      onStartShouldSetResponderCapture,
      widthInPercentage
    } = this.props;

    return (
      <View
        style={[
          styles.listcontainerstyle,
          newHomescreen ? { height: 287, width: '100% ' } : null,
          listContainerStyle
        ]}
        onStartShouldSetResponderCapture={onStartShouldSetResponderCapture}
      >
        {/* <FlatList
          ref={this.onRefListView}
          data={data}
          keyboardShouldPersistTaps={keyboardShouldPersistTaps}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          renderSeparator={renderSeparator}
          onEndReached={onEndReached}
          onEndReachedThreshold={onEndReachedThreshold}
          style={[styles.list, listStyle]}
          {...flatListProps}
        /> */}
        <ScrollView
          nestedScrollEnabled={nestedScrollEnabled || true}
          ref={this.onRefListView}
          style={[styles.list, listStyle]}
          {...flatListProps}
        >
          {data.map((item, i) => {
            return renderItem(item, i);
          })}
        </ScrollView>
      </View>
    );
  }

  renderTextInput() {
    const {
      renderTextInput,
      autoComplete,
      autoCompleteType,
      style
    } = this.props;
    const props = {
      autoCompleteType: autoCompleteType || 'name',
      // autoComplete: autoComplete || 'new-password',
      style: [styles.input, style],
      ref: this.onRefTextInput,
      onEndEditing: this.onEndEditing,
      onLayout: this.handleLayout,
      ...this.props
    };

    return renderTextInput(props);
  }

  handleLayout = ({ nativeEvent }) => {
    this.props.onLayout;
    const { height } = nativeEvent.layout;
    this.inputHeight = height;
  };

  render() {
    const {
      data,
      newHomescreen,
      containerStyle,
      hideResults,
      inputContainerStyle,
      onShowResults,
      searchIcon
    } = this.props;
    let measure = getMeasure(getWidth());
    const showResults = data.length > 0;
    let newHomescreentemp = this.props.newHomescreen ? this.props.newHomescreen : false;
    // Notify listener if the suggestion will be shown.
    onShowResults && onShowResults(showResults);
    return (
      <View
        style={[styles.container, { flexDirection: 'row' }, containerStyle]}
      >
        <View
            style={[
              styles.inputContainer,
              { width: newHomescreen ? '86%' : '95%' },
               styles[
              getResponsiveStyle(
                'inputContainer',
                measure
              )
              ]
            ]}
        >
          {this.renderTextInput()}
        </View>
        { !hideResults && showResults && this.renderResultList(newHomescreentemp)}
        {
          searchIcon === true ? (
            <View
              style={{
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {/* <Image
                style={{
                  width: 20,
                  height: 20
                }}
                resizeMode='contain'
                source={require('../assets/images/searchicon.png')}
              /> */}
            </View>
          ) : null
        }
      </View >
    );
  }
}

const styles = StyleSheet.create({
  input: {
    backgroundColor: 'white',
    height: 40,
    paddingLeft: 3,
    color: 'black',
    fontFamily: 'Mulish'
  },
  list: {
    borderColor: '#b9b9b9',
    borderRadius: 1,
    backgroundColor: 'white',
    borderWidth: 1,
    backgroundColor: 'white',
    borderTopWidth: 0,
    left: 0,
    right: 0
  },
  inputContainer: {
    paddingLeft:widthInPercentage(1),
      justifyContent:'left',
      flexDirection:'row'
  },
  listcontainerstyle: {
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 10,
    position: 'absolute',
    marginTop: 32,
    right: 0,
    width: '100%'
  }
});

export default Autocomplete;
